import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSearchParams, useLocation } from '@remix-run/react';
import { useEffect, useState } from 'react';
const AdminPanel = process.env.NODE_ENV !== 'development'
    ? () => null
    : ({ page, wordpressUrl }) => {
        var _a, _b;
        const [isOpen, setOpen] = useState(false);
        const [searchParams] = useSearchParams();
        const location = useLocation();
        const cache = searchParams.get('cache');
        useEffect(() => {
            const storageIsOpen = localStorage.getItem('headless-tools-open');
            if (storageIsOpen) {
                setOpen(storageIsOpen === 't');
            }
        }, []);
        return (_jsxs(_Fragment, { children: [_jsx("style", { type: "text/css", children: `
                .admin-panel {
                  position: fixed;
                  left: 0.75rem;
                  bottom: 0.75rem;
                  z-index: 9999;
                  height: 36px;
                  align-items: center;
                  border-radius: 0.5rem;
                  --tw-bg-opacity: 1;
                  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
                  padding-left: 0.75rem;
                  padding-right: 0.75rem;
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                  font-family: sans-serif;
                  font-size: 0.875rem;
                  line-height: 1.25rem;
                  --tw-text-opacity: 1;
                  color: rgb(255 255 255 / var(--tw-text-opacity));
                  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
                  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
                  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
                }

                .admin-panel-label {
                  margin-right: 0.25rem;
                  --tw-text-opacity: 1;
                  color: rgb(203 213 225 / var(--tw-text-opacity));
                  float: left;
                }

                .admin-panel-button {
                  display: flex;
                  align-items: center;
                  padding-left: 0.25rem;
                  padding-right: 0.25rem;
                  float: left;
                }

                .admin-panel-button-active {
                  font-weight: 700;
                  --tw-text-opacity: 1;
                  color: rgb(74 222 128 / var(--tw-text-opacity));
                  float: left;
                }

                .admin-panel-text-inactive {
                  --tw-text-opacity: 1;
                  color: rgb(203 213 225 / var(--tw-text-opacity));
                  float: left;
                  height: 20px;
                }

                .admin-panel-text-active {
                  --tw-text-opacity: 1;
                  color: rgb(74 222 128 / var(--tw-text-opacity));
                  float: left;
                  height: 20px;
                }

                .admin-panel-button-hover {
                  margin-right: 0.5rem;
                  padding-left: 0.25rem;
                  padding-right: 0.25rem;
                  float: left;
                }

                .admin-panel-button-hover:hover {
                  -webkit-text-decoration-line: underline;
                  text-decoration-line: underline;
                }

                .admin-panel-check {
                  width: 1rem;
                  height: 1rem;
                  margin-right: 0.25rem;
                }

                .admin-panel-chevron {
                  width: 1rem;
                  height: 1rem;
                  transition-property: all;
                  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                  transition-duration: 150ms;
                }

                .admin-panel-chevron-rotate {
                  --tw-rotate: 180deg;
                  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
                }
              ` }), _jsxs("div", { className: "admin-panel", children: [isOpen && (_jsxs(_Fragment, { children: [_jsx("span", { className: "admin-panel-label", children: "Cache:" }), _jsxs("a", { href: `${cache === 'use' ? location.pathname : '?cache=use'}`, className: `admin-panel-button${cache === 'use' ? ' admin-panel-button-active' : ''}`, children: [cache === 'use' && (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "4", strokeLinecap: "round", strokeLinejoin: "round", className: "admin-panel-check", children: _jsx("polyline", { points: "20 6 9 17 4 12" }) })), "use"] }), _jsx("span", { className: "admin-panel-text-inactive", style: { fontSize: 12 }, children: "/" }), _jsx("a", { href: "?cache=empty", className: "admin-panel-button-hover", children: "empty" }), (page === null || page === void 0 ? void 0 : page.databaseId) && ((_b = (_a = page === null || page === void 0 ? void 0 : page.contentType) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.name) && (_jsxs(_Fragment, { children: [_jsx("span", { className: "admin-panel-label", children: "Page:" }), _jsx("a", { href: `${wordpressUrl}/wp-admin/post.php?post=${page.databaseId}&action=edit`, target: "_blank", className: "admin-panel-button-hover", rel: "noreferrer", children: "edit" })] }))] })), _jsx("button", { type: "button", onClick: () => {
                                const newOpen = !isOpen;
                                setOpen(newOpen);
                                localStorage.setItem('headless-tools-open', newOpen ? 't' : 'f');
                            }, className: cache === 'use' && !isOpen ? 'admin-panel-text-active' : 'admin-panel-text-inactive', children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", className: `admin-panel-chevron${!isOpen ? ' admin-panel-chevron-rotate' : ''}`, children: _jsx("polyline", { points: "15 18 9 12 15 6" }) }) })] })] }));
    };
export default AdminPanel;
